"use strict";
// Who lodges the dossier with the town hall.
//
// The two routes put OPPOSITE instructions in front of the commercial, which is
// the whole reason this is recorded: until it was, every commercial was told to
// collect signatures and go to the mairie, including on dossiers the architect
// was about to lodge online for them.
//
// The architect chooses at the moment they hand the documents over
// (`project/file/send`); nothing else may write it.
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositedByArchitect = exports.isDepositMode = exports.DEPOSIT_MODES = exports.DepositMode = void 0;
exports.DepositMode = {
    /** The commercial has the documents signed and lodges them at the mairie. */
    CLIENT: 'CLIENT',
    /** We lodge them on the commune's online platform. Nothing for the commercial to do. */
    ARCHITECT: 'ARCHITECT',
};
/** The two values as a tuple — the shape `z.enum()` wants. */
exports.DEPOSIT_MODES = ['CLIENT', 'ARCHITECT'];
const isDepositMode = (value) => value === exports.DepositMode.CLIENT || value === exports.DepositMode.ARCHITECT;
exports.isDepositMode = isDepositMode;
/**
 * What the commercial is told to do at PROJECT_FILE_SENT, and afterwards.
 *
 * `null` — nobody chose. Every dossier sent before the column existed is in this
 * state, and the honest reading is the assumption they were sent under: the
 * commercial lodges. So it falls back to the CLIENT copy rather than inventing a
 * neutral sentence that would change what those dossiers appear to say.
 */
const depositedByArchitect = (mode) => mode === exports.DepositMode.ARCHITECT;
exports.depositedByArchitect = depositedByArchitect;
//# sourceMappingURL=deposit-mode.js.map